import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveUserInbox as RemoveUserInboxMutation,
    RemoveUserInboxVariables as RemoveUserInboxVariables,
    UserInboxRemoveInput,
} from 'nutshell-graphql-types';

import REMOVE_USER_INBOX from '../mutations/remove-user-inbox.graphql';
import GET_USER_INBOXES from '../queries/get-user-inboxes.graphql';

export const useRemoveUserInbox = (): {
    removeUserInbox: (arg1: UserInboxRemoveInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeUserInbox, {loading, error}] = useMutation<
        RemoveUserInboxMutation,
        RemoveUserInboxVariables
    >(REMOVE_USER_INBOX);

    return {
        removeUserInbox: (input: UserInboxRemoveInput) => {
            return removeUserInbox({
                variables: {input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    userInboxRemove: {
                        __typename: 'UserInboxRemovePayload',
                        user: {
                            __typename: 'User',
                            id: input.userId,
                        },
                    },
                },
                update: (proxy, mutationResults) => {
                    const newUser =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.userInboxRemove &&
                        mutationResults.data.userInboxRemove.user;

                    if (newUser) {
                        const cacheResult = proxy.readQuery({
                            query: GET_USER_INBOXES,
                            variables: {threadType: input.threadType},
                        });

                        if (cacheResult) {
                            proxy.writeQuery({
                                query: GET_USER_INBOXES,
                                variables: {threadType: input.threadType},
                                data: {
                                    // @ts-expect-error
                                    userInboxes: cacheResult.userInboxes.filter(
                                        // @ts-expect-error
                                        (user) => user.id !== newUser.id
                                    ),
                                },
                            });
                        }
                    }
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
